import UseContext from 'hooks/useContext';
import Usefetchdata from 'hooks/usefetchdata';
import { Link, useLocation } from 'react-router-dom';
import {
  MOBILE_TABS,
  isLinkActive,
  isLinkVisible,
  linkLabel,
} from './sidebarLinks';

const HamburgerIcon = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4 6H20M4 12H20M4 18H20"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const TAB =
  'flex flex-col items-center justify-center gap-0.5 transition-colors duration-150';
const tabTone = (active) =>
  active ? 'text-yellow-500' : 'text-gray-500 hover:text-yellow-500';

// The bar fixed at the bottom of a phone: the main pages, then « Plus », which
// opens the whole sidebar as a drawer.
const SidebarMobile = () => {
  const { pathname } = useLocation();
  const { sidebarOpen, setSidebarOpen, language } = UseContext();
  const { userData } = Usefetchdata();

  return (
    <nav className="safe-area-bottom fixed bottom-0 left-0 right-0 z-30 h-[72px] w-full border-t border-gray-100 bg-[#FCFCFC]">
      <ul className="flex h-full items-center justify-around px-2">
        {MOBILE_TABS.filter((link) => isLinkVisible(link, userData)).map(
          (link) => {
            const Icon = link.icon;
            const active = isLinkActive(link, pathname);
            return (
              <li key={link.key}>
                <Link
                  to={link.to}
                  aria-current={active ? 'page' : undefined}
                  className={`${TAB} ${tabTone(active)}`}
                >
                  <Icon wh={28} color="currentColor" />
                  <span className="text-center text-[9px]">
                    {linkLabel(language, link)}
                  </span>
                </Link>
              </li>
            );
          }
        )}
        <li>
          <button
            type="button"
            onClick={() => setSidebarOpen(!sidebarOpen)}
            aria-label={language.getValue('sidebar.open_menu', 'Ouvrir le menu')}
            aria-expanded={sidebarOpen}
            aria-controls="sidebar"
            className={`${TAB} ${tabTone(sidebarOpen)}`}
          >
            <HamburgerIcon />
            <span className="text-center text-[9px]">
              {language.getValue('sidebar.more', 'Plus')}
            </span>
          </button>
        </li>
      </ul>
    </nav>
  );
};

export default SidebarMobile;
